export const SUPPORTS_ARRAY_PROTOTYPE_FOR_EACH = "forEach" in Array.prototype;
